export default "__VITE_ASSET__Cvg_L9g2__"